import { Route, Routes } from "react-router-dom";

import { CollectionPage } from "./pages/CollectionPage";
import { PlantPage } from "./pages/PlantPage";
import { TodayPage } from "./pages/TodayPage";

export function App() {
  return (
    <Routes>
      {/* Today is the front door: the app's job is to say what needs doing. */}
      <Route path="/" element={<TodayPage />} />
      <Route path="/plants" element={<CollectionPage />} />
      <Route path="/plants/:id" element={<PlantPage />} />
    </Routes>
  );
}
